import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

// Map public routes → human-readable page label. Unknown routes drop the
// per-page prefix and just use the suffix on its own.
const ROUTE_LABEL = {
  "/": null,                            // homepage = just the brand
  "/news": "News",
  "/videos": "Videos",
  "/stats": "Match centre",
  "/blast-from-the-past": "Retro",
  "/spotify": "Playlist",
  "/social": "#PUSB wall",
  "/archive": "Archive",
  "/contact": "Contact",
  "/privacy": "Privacy",
  "/legal": "Legal",
  "/admin": "Admin",
  "/admin/login": "Sign in",
};

/**
 * Updates document.title on every navigation, stitching the per-page label
 * onto the brand suffix from theme.tab_title_suffix.
 *
 * Examples (suffix = "LAST"):
 *   /             → "LAST"
 *   /news         → "News · LAST"
 *   /admin        → "Admin · LAST"
 *   /post/abc-123 → "LAST" (unknown route)
 */
export default function DocumentTitle() {
  const { pathname } = useLocation();
  const { theme } = useTheme();

  useEffect(() => {
    const suffix = theme.tab_title_suffix || "LAST";
    const label =
      ROUTE_LABEL[pathname] ?? (pathname.startsWith("/admin") ? "Admin" : null);
    document.title = label ? `${label} · ${suffix}` : suffix;
  }, [pathname, theme.tab_title_suffix]);

  return null;
}
